import api                                           from '@/libs/axios'
import { addOrUpdateInList, cleanEntityToSend }      from '../../utils/form'
import Vue                                           from 'vue'
import ToastificationContent                         from '@/components/toastification/ToastificationContent.vue'
import { capitalize }                                from '@/utils/filter'
import i18n                                          from '@/libs/i18n'
import store                                         from '../index'
import useAppConfig                                  from '../../utils/useAppConfig'
import useAPI                                        from '../../utils/useAPI'
import qs                                            from 'qs'
import { arrayUtcToTz, clone, eventToCalendarEvent } from '../../utils/utils'
import router                                        from '../../router'

export default {
  getEvents ({ commit, state }, payload) {
    store.commit('app/TOGGLE_LOADING', true)

    return new Promise((resolve, reject) => {
      api.get('/events2' + '?' + qs.stringify(payload))
        .then(response => {
          // console.log(response)
          arrayUtcToTz(response.data.results)

          commit('SET_EVENTS', response.data.results)
          commit('SET_EVENTSCONTEXT', response.data.page_context)
          store.commit('app/TOGGLE_LOADING', false)

          resolve(response)
        })
        .catch(err => {
          console.log('Error', err)
          // reject(err)
        })
    })

  },
  getEvent ({ commit, state }, eventId) {
    store.commit('app/ADD_LOADER')

    return new Promise((resolve, reject) => {
      api.get('/events/' + eventId)
        .then(response => {
          arrayUtcToTz([response.data])

          addOrUpdateInList(response.data, state.events, 'event', commit)

          store.commit('app/REMOVE_LOADER')
          resolve(response)

        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  async addEvent ({ commit, state }, event) {
    console.log(clone(event))
    if (event.subType == "holiday") {
      event.type = 'absence'
    }

    return await cleanEntityToSend(event, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.post('/events', clonedEntityToSend)
            .then(response => {
              commit('ADD_EVENT', response.data)
              store.commit('calendar/ADD_EVENT', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The event has been ', { crud: i18n.t('created') }),
                  variant: 'success'
                },
              })

              if (
                router.history.current.name == 'WorkFlo view' &&
                clone(store.getters['workFlo/getWorkFloHistory']) != { comingSoon: [], history: [] }
              ) {
                store.dispatch('workFlo/getWorkFloHistory', store.getters['workFlo/getCurrentWorkFlo'].id)
              }

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  async updateEvent ({ commit, state }, event) {
    return await cleanEntityToSend(event, state.params)
      .then(async clonedEntityToSend => {

        return new Promise((resolve, reject) => {
          api.put('/events/' + event.id, clonedEntityToSend)
            .then(response => {
              commit('UPDATE_EVENT', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The event has been ', { crud: i18n.t('edited') }),
                  variant: 'success'
                },
              })

              if (
                router.history.current.name == 'WorkFlo view' &&
                clone(store.getters['workFlo/getWorkFloHistory']) != { comingSoon: [], history: [] }
              ) {
                store.dispatch('workFlo/getWorkFloHistory', store.getters['workFlo/getCurrentWorkFlo'].id)
              }

              resolve(response)
              // resolve(JSON.parse(JSON.stringify(response)))
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  removeEvent ({ commit }, event) {
    return new Promise((resolve, reject) => {
      api.delete('/events/' + event.id)
        .then(response => {
          commit('REMOVE_EVENT', event)

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: capitalize(i18n.t('success')),
              icon: 'check',
              text: i18n.t('The event has been ', { crud: i18n.t('removed') }),
              variant: 'success'
            },
          })

          if (
            router.history.current.name == 'WorkFlo view' &&
            clone(store.getters['workFlo/getWorkFloHistory']) != { comingSoon: [], history: [] }
          ) {
            store.dispatch('workFlo/getWorkFloHistory', store.getters['workFlo/getCurrentWorkFlo'].id)
          }

          resolve(response)
        })
        .catch(error => {
          console.log('Error', error)
          reject(error)
        })
    })
  },

}